export default {
  'servicesOverview.tag': '專業服務',
  'servicesOverview.title': '我們的服務',
  'servicesOverview.desc':
    '在全球主要司法管轄區提供金融及企業諮詢服務，涵蓋海外基金設立、金融牌照申請、海外公司設立與公司併購等全流程支持。',
  'servicesOverview.cta': '了解詳情',

  'servicesOverview.lines.overseasFund.label': '海外基金設立',
  'servicesOverview.lines.overseasFund.desc':
    '協助客戶在愛爾蘭、盧森堡、馬耳他等歐洲主要司法管轄區設立境外投資基金，涵蓋結構規劃、監管申報及持續合規。',
  'servicesOverview.lines.overseasFund.tags.0': 'UCITS / AIF',
  'servicesOverview.lines.overseasFund.tags.1': '歐盟護照',
  'servicesOverview.lines.overseasFund.tags.2': '持續合規',

  'servicesOverview.lines.financialLicensing.label': '金融牌照申請',
  'servicesOverview.lines.financialLicensing.desc':
    '為英國、愛爾蘭、立陶宛、瑞士等多個司法管轄區申請金融服務牌照提供全程支持，包括電子銀行、外匯經紀、支付及加密資產等牌照類型。',
  'servicesOverview.lines.financialLicensing.tags.0': 'EMI / 支付',
  'servicesOverview.lines.financialLicensing.tags.1': '外匯經紀',
  'servicesOverview.lines.financialLicensing.tags.2': '加密資產',

  'servicesOverview.lines.overseasCompany.label': '海外公司設立',
  'servicesOverview.lines.overseasCompany.desc':
    '為英國、愛爾蘭、葡萄牙、立陶宛、馬耳他等司法管轄區註冊公司提供專業指導，包括註冊地址、銀行開戶及持續秘書服務。',
  'servicesOverview.lines.overseasCompany.tags.0': '歐洲註冊',
  'servicesOverview.lines.overseasCompany.tags.1': '離岸架構',
  'servicesOverview.lines.overseasCompany.tags.2': '秘書服務',

  'servicesOverview.lines.mergersAcquisitions.label': '公司併購',
  'servicesOverview.lines.mergersAcquisitions.desc':
    '為跨境併購交易提供戰略諮詢，包括持牌公司收購、盡職調查協調及併購後整合支持。',
  'servicesOverview.lines.mergersAcquisitions.tags.0': '持牌收購',
  'servicesOverview.lines.mergersAcquisitions.tags.1': '盡職調查',
  'servicesOverview.lines.mergersAcquisitions.tags.2': '併購整合',

  'services.detail.overseas-fund-setup.title': '海外基金設立',
  'services.detail.overseas-fund-setup.summary':
    '協助客戶在愛爾蘭、盧森堡、馬耳他等歐洲主要司法管轄區設立境外投資基金，涵蓋結構規劃、監管申報及持續合規。',
  'services.detail.overseas-fund-setup.content': `## 基金類型

在歐盟（含英國），主要有兩大基金形式：

- **UCITS（可轉讓證券集合投資型基金）** — 主要針對零售型投資人，流動性相對較強，通常為開放式基金。可投資股票、債券等可轉讓證券。符合 UCITS 要求的基金可享受歐盟護照制度，在歐盟市場內銷售。
- **另類投資型基金（AIF）** — 主要針對有投資經驗的專業型投資人。類型包括不動產基金、私募股權基金、對沖基金、另類投資組合型基金、商品基金、基礎建設基金及不在 UCITS 範圍內的債權基金等。符合 AIFMD 要求的基金同樣可受益於歐盟護照制度。

## 設立基金時應考慮的因素

- 目標投資人及基金規模
- 投資策略、資產類型及基金註冊地
- 市場分銷策略
- 設立成本及後續維護成本
- 選擇合適的基金類型，以及單一基金或傘形基金的選擇
- 潛在的稅收優惠
- 基金運營生態圈

## 所需金融服務合作方及費用

- **本地董事** — 須有相關從業經驗，費用因註冊地不同而異
- **持牌基金管理人（AIFM/Manco）** — 通常為淨資產的 0.3% 至 1%
- **基金託管行（Depositary）** — 通常為淨資產的 0.05% 至 0.10%，可能設有年度最低託管費
- **基金行政管理機構（Fund Administrator）** — 通常為淨資產的 0.10% 至 0.30%
- **基金審計師** — 根據規模及複雜程度收取
- **基金法律顧問** — 根據運營需求收取

## 我們提供的服務

- 根據客戶商業模式及計劃投資規模、資產類型建議合適的基金形式
- 在當地為客戶註冊基金公司（私人有限公司、信託公司或開放式投資公司等）
- 幫助客戶建立專業管理團隊，包括持牌人、合規官及董事成員
- 協助律師撰寫基金說明書、股權認購書、子基金說明書、運營企劃案及財務預算等
- 介紹符合監管要求的金融服務方，並代表客戶審核相關合同
- 代表客戶向監管機構遞交基金授權申請
- 審核期間代表客戶回覆監管機構問詢或出席面試

## 可協助申辦的監管機構

- 英國金融行為監管局（FCA）
- 愛爾蘭中央銀行
- 立陶宛中央銀行
- 葡萄牙中央銀行`,

  'services.detail.financial-licensing.title': '金融牌照申請',
  'services.detail.financial-licensing.summary':
    '為客戶在英國、愛爾蘭、立陶宛、瑞士等多個司法管轄區申請金融服務牌照提供全程支持，包括電子銀行牌照、外匯經紀商牌照、支付牌照、虛擬貨幣交易牌照及 ICO 牌照。',
  'services.detail.financial-licensing.content': `## 牌照類型

### 外匯經紀商牌照

英國外匯交易牌照主要分為三類：

- **做市商牌照（MM）** — 為投資者提供獨立買賣交易平台，可持有客戶資金及自營交易。最低註冊資金：73 萬歐元。
- **STP 牌照（撮合配對交易）** — 作為中間商撮合交易，可持有客戶資金但不能自營交易。最低註冊資金：12.5 萬歐元。
- **推廣券商牌照** — 為客戶介紹持牌公司，不可持有客戶資金。最低註冊資金：5 萬歐元。

### 電子銀行牌照（EMI）

電子銀行牌照除可提供支付牌照的全部業務外，還可提供：開設支付賬戶、發行儲蓄卡/信用卡、消費貸款、區塊鏈穩定電子貨幣發行及 P2P 服務（附加授權）。最低註冊資金：35 萬歐元。審批時間：通常 4-5 個月。

### 支付牌照

主要為企業及個人提供國際支付及轉賬服務，包括支付賬戶、第三方支付、收款工具及匯款等。最低註冊資金：匯款 2 萬歐元，商家收款 5 萬歐元，支付賬戶 12.5 萬歐元。審批時間：6-12 個月。

### 信託公司牌照（澤西島）

兩種形式：**管理信託公司**（依附已持牌公司，申請難度較低）或**信託牌照全牌公司**（可管理全球範圍內的信託，申請較複雜）。審批時間：6-8 個月。需在澤西島設有完整運營，至少 5 名董事（多數須為本地居民），合規官及反洗錢官須分設。

### 虛擬貨幣/加密資產牌照

協助客戶在波蘭、BVI、開曼群島、馬耳他等多個司法管轄區申請加密貨幣牌照，同時支持歐盟 MiCAR CASP 加密資產服務商牌照申請。

### 消費信貸牌照（英國）

分為有限許可（消費者租賃、附屬信貸經紀）及全牌照（所有信貸類型、債務管理、P2P 借貸）。無最低資本要求（債務管理除外）。通過 FCA Connect 在線系統申請。

### 消費信貸牌照（立陶宛 & 愛沙尼亞）

立陶宛：材料齊全後 2-3 個月可獲批；可與 EMI/支付牌照結合覆蓋整個歐盟。愛沙尼亞：由 Finantsinspektsioon 頒發，無到期日，涵蓋債權人及抵押債權人兩類；審批時間 6-8 個月。

## 我們提供的服務

- 根據商業模式建議最合適的牌照類型
- 當地公司註冊
- 幫助準備預申請材料及問卷，協助或代表客戶出席預申請面試
- 撰寫申請表、商業計劃書、運營企劃案及財務預算
- 建立專業管理團隊，包括持牌人、合規官及董事成員
- 協助 IT 系統開發
- 遞交後代表客戶回覆監管機構問詢

## 可協助申辦的監管機構

- 英國 FCA
- 愛爾蘭中央銀行
- 立陶宛中央銀行
- 葡萄牙中央銀行
- 瑞士 FINMA / SRO
- 澤西島金融服務委員會（JFSC）
- 歐盟及離岸各司法管轄區監管機構`,

  'services.detail.overseas-company.title': '海外公司設立',
  'services.detail.overseas-company.summary':
    '為客戶在英國、愛爾蘭、葡萄牙、立陶宛、馬耳他等司法管轄區註冊公司提供專業指導，包括註冊地址、銀行開戶及持續秘書服務。',
  'services.detail.overseas-company.content': `## 主要註冊地

我們可協助客戶在以下司法管轄區註冊公司：

- **歐洲：**愛爾蘭、英國、葡萄牙、立陶宛、馬耳他、瑞士、荷蘭、西班牙、匈牙利、馬恩島
- **離岸地區：**BVI、開曼群島、多米尼加、格林納達、聖盧西亞、毛里求斯（GBC1）
- **其他：**尼日利亞、塞爾維亞等

## 為何選擇海外註冊？

- 獲取特定金融監管資質及歐盟護照權利
- 稅務優化與資產保護
- 提升國際公信力及市場准入
- 用於投資或知識產權的控股架構

## 我們提供的服務

- 公司名稱搜索及預留
- 準備並提交所有註冊文件
- 提供註冊地址
- 介紹本地董事及公司秘書
- 銀行開戶協助
- 持續秘書及合規服務
- 協助滿足當地實質性要求`,

  'services.detail.mergers-acquisitions.title': '公司併購',
  'services.detail.mergers-acquisitions.summary':
    '為跨境併購交易提供戰略諮詢，包括持牌公司收購、盡職調查協調及併購後整合支持。',
  'services.detail.mergers-acquisitions.content': `## 併購諮詢服務

為跨境併購及持牌實體交易提供全程支持，覆蓋歐洲及全球主要司法管轄區。

## 可供收購的持牌資產

我們維護著一批可供收購的持牌實體，包括：

- 持牌投資公司（如盧森堡 MiFID 持牌公司）
- EMI 及支付機構牌照持有人（荷蘭、波蘭）
- 全牌照銀行（科摩羅安儒昂、波多黎各）
- 持有支付牌照的加密貨幣交易所（波蘭）
- 葡萄牙及其他歐盟銀行牌照

## 我們的服務流程

- 初步篩選及目標識別
- 初步盡職調查及監管狀態審查
- 架構建議及交易談判支持
- 協調法律、合規及財務盡職調查
- 監管變更控制申報及審批支持
- 併購後整合規劃

## 為何收購持牌實體？

- 相比從零申請牌照，市場進入速度更快
- 即刻具備運營能力
- 已有監管關係及合規基礎設施`,

  'seo.services.title': '服務',
  'seo.services.desc':
    '海外基金設立、金融牌照申請、海外公司設立與公司併購等跨境金融與企業諮詢服務。',
  'seo.services.keywords':
    'GEEL TEC, 服務, 海外基金, 金融牌照, 海外公司設立, 公司併購, 跨境諮詢',

  'seo.services.overseas-fund-setup.title': '海外基金設立',
  'seo.services.overseas-fund-setup.desc':
    '愛爾蘭、盧森堡、馬耳他等地境外基金設立，涵蓋 UCITS/AIF 結構規劃、監管申報與持續合規。',
  'seo.services.overseas-fund-setup.keywords':
    'GEEL TEC, 海外基金, UCITS, AIF, 基金設立, 歐盟基金, 基金合規',

  'seo.services.financial-licensing.title': '金融牌照申請',
  'seo.services.financial-licensing.desc':
    '英國、愛爾蘭、立陶宛、瑞士等地 EMI、支付、外匯經紀與加密資產等金融牌照申請全程支持。',
  'seo.services.financial-licensing.keywords':
    'GEEL TEC, 金融牌照, EMI, 支付牌照, 外匯牌照, 加密資產牌照, FCA',

  'seo.services.overseas-company.title': '海外公司設立',
  'seo.services.overseas-company.desc':
    '歐洲及離岸司法管轄區公司註冊、秘書服務、銀行開戶與實質性合規支持。',
  'seo.services.overseas-company.keywords':
    'GEEL TEC, 海外公司, 公司註冊, 離岸公司, 秘書服務, 銀行開戶',

  'seo.services.mergers-acquisitions.title': '公司併購',
  'seo.services.mergers-acquisitions.desc':
    '跨境併購與持牌實體收購，涵蓋目標篩選、盡職調查、監管申報與併購後整合。',
  'seo.services.mergers-acquisitions.keywords':
    'GEEL TEC, 公司併購, 持牌收購, 盡職調查, 跨境併購, 併購整合',
};
